export const caretakerQualificationPath = '/caretaker/qualification'
export const caretakerCurriculumPath = '/caretaker/cv'
export const caretakerServicesPath = '/caretaker/service-length'
export const customerServicesPath = '/customer/service-length'
export const newRecommendationServicePath = '/new-recommendation-service'
export const newRecommendationServiceOutSessionPath = '/new-guest-recommendation-service'
export const newRecommendationServiceSelectedCaretakerPath = caretakerId =>
  `/new-recommendation-service-selected-caretaker/${caretakerId}`
export const newRecommendationServiceSelectedCaretakerOutSessionPath = caretakerId =>
  `/new-guest-recommendation-service-selected-caretaker/${caretakerId}`
export const newRecruitingServicePath = '/new-recruiting-service'
export const confirmRecruiterRequestPath = requestId => `/recruiting-request/${requestId}/select-caretaker`



// WEBPACK FOOTER //
// ./src/infrastructure/routes.ts